var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { createStyles, withStyles, } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import { Logo } from './Logo';
import { CentralProviderContext } from '../..';
import { isDark } from '../../types/Theme';
var styles = function () { return createStyles({
    main: {
        width: 'auto',
    },
    logo: {
        paddingTop: '0',
        marginLeft: 'var(--margin-sidebar)',
    },
}); };
export var LogoHeader = withStyles(styles)(withRouter(function (props) {
    var classes = props.classes, onNavigate = props.onNavigate, history = props.history, logoType = props.logoType;
    var dark = isDark();
    var centralProviderContext = useContext(CentralProviderContext);
    return (React.createElement(Grid, { container: true, className: classes.main },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(CardMedia, { className: classes.logo, title: logoType === 'michelin' ? 'Michelin' : 'Maestro', style: { cursor: 'pointer' }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, accountPath;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = onNavigate;
                                if (!_a) return [3 /*break*/, 2];
                                return [4 /*yield*/, onNavigate()];
                            case 1:
                                _a = !(_b.sent());
                                _b.label = 2;
                            case 2:
                                if (_a)
                                    return [2 /*return*/];
                                if (centralProviderContext.selectedGrantLocation) {
                                    accountPath = "/".concat(centralProviderContext.selectedGrantLocation.customer_number);
                                    if (history.location.pathname.indexOf(accountPath) === 0) {
                                        history.push(accountPath);
                                        return [2 /*return*/];
                                    }
                                }
                                history.push('/');
                                return [2 /*return*/];
                        }
                    });
                }); } },
                React.createElement(Logo, { darkMode: dark, logoType: logoType, lang: centralProviderContext.currentLanguage })))));
}));
//# sourceMappingURL=LogoHeader.js.map